import tippy, { animateFill } from 'tippy.js';
import 'tippy.js/dist/tippy.css';
import 'tippy.js/dist/backdrop.css';
import 'tippy.js/animations/shift-away.css';
import { trapFocus } from './utils.js';

const hideOnEsc = {
    name: 'hideOnEsc',
    defaultValue: true,
    fn({hide}) {
      function onKeyDown(event) {
        if (event.keyCode === 27) {
          hide();
        }
      }
  
      return {
        onShow() {
          document.addEventListener('keydown', onKeyDown);
        },
        onHide() {
          document.removeEventListener('keydown', onKeyDown);
        },
      };
    },
};

function syncFilterValues(instance) {
    const filterGroupId = instance.reference.getAttribute('data-tippy-content-id');
    const hiddenContent = document.getElementById(filterGroupId);
    if (hiddenContent) {
        const checked = Array.from(hiddenContent.querySelectorAll('input[type="checkbox"]:checked'))
            .map(cb => cb.value);
        instance.popper.querySelectorAll('input[type="checkbox"]').forEach(cb => {
            cb.checked = checked.includes(cb.value);
        });
    }
}

function syncToHiddenSource(list, filterGroupId) {
    const hiddenContent = document.getElementById(filterGroupId);
    if (hiddenContent) {
        list.querySelectorAll('input[type="checkbox"]').forEach(tippyCb => {
            const hiddenCb = hiddenContent.querySelector(`input[type="checkbox"][value="${tippyCb.value}"]`);
            if (hiddenCb) hiddenCb.checked = tippyCb.checked;
        });
    }
}

function handleCheckboxLogic(currentCheckbox, list) {
    const isAllCheckbox = currentCheckbox.value === 'all';
    const otherCheckboxes = list.querySelectorAll('input[type="checkbox"]:not([value="all"])');
    const allCheckbox = list.querySelector('input[type="checkbox"][value="all"]');

    if (isAllCheckbox && currentCheckbox.checked) {
        otherCheckboxes.forEach(cb => cb.checked = false);
    } else if (!isAllCheckbox && currentCheckbox.checked) {
        if (allCheckbox) allCheckbox.checked = false;
    }
    const allOthersUnchecked = Array.from(otherCheckboxes).every(cb => !cb.checked);
    if (allOthersUnchecked && allCheckbox) allCheckbox.checked = true;
}

function gatherProductVars() {
    const filterVars = {};
    const filterLabels = {};
    document.querySelectorAll('.product-filter-form>.product-filter-dropdown-content ul').forEach(ul => {
        const parent = ul.closest('.product-filter-dropdown-content');
        if (!parent) return;
        const id = parent.id.replace('tippy-', '');
        const checked = Array.from(ul.querySelectorAll('input[type="checkbox"]:checked'))
            .map(cb => cb.value);
        // if the ul is checked add it to the filterLabels
        checked.forEach(cb => {
            const label = ul.querySelector(`input[type="checkbox"][value="${cb}"]`).closest('label').textContent.trim().toLowerCase();
            if (!filterLabels[id]) {
                filterLabels[id] = [];
            }
            filterLabels[id].push(label);
        });
        filterVars[id] = checked;
    });
    updateUrlFromFilters(filterLabels);
    triggerAjax(filterVars);
}

function triggerAjax(filterVars) {
    fetch(ajax_global.url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams({
            action: "product_filter",
            nonce: ajax_global.nonce,
            filterVars: JSON.stringify(filterVars)
        })
    })
    .then(response => response.json())
    .then(r => {
        const productGrid = document.querySelector('#product-grid');
        if (r.success) {
            productGrid.innerHTML = r.data.html;
            updateActiveFilters(r.data.activeFilters, r.data.count);
        } else {
            productGrid.innerHTML = r.data.html;
        }
    })
    .catch(error => {
        console.error('Error:', error);
    });
}

function updateActiveFilters(activeFilters, count) {
    const activeFiltersContainer = document.querySelector('.product-filter__active-filters');
    const productFilterActiveFilters = document.getElementById('product-filter-active-filters');
    const countText = document.getElementById('product-filter-count');
    if (activeFilters.length > 0) {
        activeFiltersContainer.classList.add('active');
        productFilterActiveFilters.innerHTML = '';
        activeFilters.forEach(filter => {
            const filterContainer = document.createElement('div');
            filterContainer.className = 'product-filter__active-filters-item';
            filterContainer.innerHTML = `<span class="product-filter__active-filters-item-title">${filter.label}</span><a href="javascript:void(0)" class="btn btn--clear-filter" data-filter="${filter.filter}" data-value="${filter.value}"><span class="visually-hidden">Clear</span></a>`;
            productFilterActiveFilters.appendChild(filterContainer);
        });
        if (countText) {
            if (count > 1) {
                countText.textContent = count + ' matching products';
            } else {
                countText.textContent = count + ' matching product';
            }
        }
    } else {
        activeFiltersContainer.classList.remove('active');
        if (countText) countText.textContent = '';
    }
}

function setFiltersFromUrl() {
    const params = new URLSearchParams(window.location.search);
    let anySet = false;
    if(!params) return;
    document.querySelectorAll('.product-filter-form>.product-filter-dropdown-content ul').forEach(ul => {
        const parent = ul.closest('.product-filter-dropdown-content');
        if (!parent) return;
        const id = parent.id.replace('tippy-', '');
        if (params.has(id)) {
            anySet = true;
            // Support multiple values, comma-separated
            const values = decodeURIComponent(params.get(id)).split(',').map(v => v.trim().toLowerCase());
            ul.querySelectorAll('input[type="checkbox"]').forEach(cb => {
                // Find the label text for this checkbox
                let label = cb.closest('label');
                let labelText = '';
                if (label) {
                    labelText = label.textContent.trim().toLowerCase();
                }
                cb.checked = values.includes(labelText);
            });
            // Uncheck 'all' if any other is checked
            const allCb = ul.querySelector('input[type="checkbox"][value="all"]');
            if (allCb && values.some(v => v !== 'all')) allCb.checked = false;
        }
    });
    if (anySet) gatherProductVars();
}

function updateUrlFromFilters(filterLabels) {
    const params = new URLSearchParams();
    Object.entries(filterLabels).forEach(([key, values]) => {
        // Only add if there are non-'all' values
        if(values.some(value => value.includes('all '))) { return; }
        params.set(key, encodeURIComponent(values.join(',')));
    });
    const newUrl = window.location.pathname + (params.toString() ? '?' + params.toString() : '');
    window.history.replaceState({}, '', newUrl);
}

document.addEventListener('DOMContentLoaded', function() {
    setFiltersFromUrl();
    tippy('.product-filter-dropdown', {
        content(reference) {
            const id = reference.getAttribute('data-tippy-content-id');
            const template = document.getElementById(id);
            return `<div class="product-filter-dropdown-content">${template.innerHTML}</div>`;
        },
        allowHTML: true,
        interactive: true,
        trigger: 'click',
        placement: 'bottom-start',
        arrow: false,
        hideOnClick: false,
        plugins: [hideOnEsc],
        appendTo: reference => reference,
        onShow(instance) {
            instance.popper.classList.add('filter-popper');
            instance.reference.classList.add('active');
            syncFilterValues(instance);
            const content = instance.popper.querySelector('.product-filter-dropdown-content');
            const checkboxes = content.querySelectorAll('input[type="checkbox"]');
            trapFocus(content);
            checkboxes.forEach(checkbox => {
                checkbox.addEventListener('change', (event) => {
                    const currentCheckbox = event.currentTarget;
                    const list = currentCheckbox.closest('ul');
                    handleCheckboxLogic(currentCheckbox, list);
                    const filterGroupId = instance.reference.getAttribute('data-tippy-content-id');
                    syncToHiddenSource(list, filterGroupId);
                    gatherProductVars();
                });
            });
        },
        onHide(instance) {
            instance.reference.classList.remove('active');
        },
        onClickOutside(instance) {
            instance.hide();
        }
    });

    document.querySelectorAll('.product-filter-dropdown .product-filter-bar__item-title').forEach(item => {
        item.addEventListener('click', function(e) {
            if(e.target.parentElement.classList.contains('active')) {
                e.preventDefault();
                e.stopPropagation();
                e.target.parentElement._tippy.hide();
            }
        });
    });

    if (document.querySelector('.product-filter__active-filters')) {
        document.querySelector('.product-filter__active-filters').addEventListener('click', function(e) {
            if (e.target.classList.contains('btn--clear-filter')) {
                const value = e.target.getAttribute('data-value');
                const filter = e.target.getAttribute('data-filter');
                const hidden = document.getElementById('tippy-' + filter);
                if (hidden) {
                    const cb = hidden.querySelector(`input[type="checkbox"][value="${value}"]`);
                    if (cb) {
                        cb.checked = false;
                        const allCb = hidden.querySelector('input[type="checkbox"][value="all"]');
                        const others = hidden.querySelectorAll('input[type="checkbox"]:not([value="all"])');
                        if (Array.from(others).every(cb => !cb.checked) && allCb) allCb.checked = true;
                    }
                }
                gatherProductVars();
            }
            if (e.target.classList.contains('btn--clear-filters')) {
                document.querySelectorAll('.product-filter-dropdown-content').forEach(content => {
                    const allCb = content.querySelector('input[type="checkbox"][value="all"]');
                    const others = content.querySelectorAll('input[type="checkbox"]:not([value="all"])');
                    others.forEach(cb => cb.checked = false);
                    if (allCb) allCb.checked = true;
                });
                gatherProductVars();
            }
        });
    }

    const filterByGroup = document.querySelector('.filter-by-group');
    const filterByTrigger = document.querySelector('.filter-by-trigger');
    const productFilterBar = document.querySelector('.product-filter-bar');
    const filterByLabel = document.querySelector('.filter-by-label');
    if(filterByTrigger) {
        filterByTrigger.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            productFilterBar.classList.toggle('mobile-open');
        });
    }
});